import React from 'react';
import { titleCase, get } from "@dex/bubl-helpers";
import PaymentApi from './PaymentApi';
import PaymentActions from './Components/PaymentActions';

let settings;

export default settings = {
    key: 'shop/payment',
    zone: 'shop',
    path: '/shop/payment',
    title: "Payments",
    endpoint: PaymentApi.endpoint,
    modelName: 'Payment',
    idKey: 'id',
    primaryKey: 'id',
    indexCaps: ["viewPayment"],
    viewCaps: ["viewPayment"],
    createCaps: ["createPayment"],
    indexTitle: (routeName, params, users) => {

        let title: string = settings.title;

        if (params && params.name) title = title + " / " + titleCase(params.name);

        return title;

    },
    indexTabs: (routeName, params, users) => {

        return [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            // {
            //     label: "Paid",
            //     path: settings.path + "/status/paid"
            // },
            // {
            //     label: "Due",
            //     path: settings.path + "/status/due"
            // },
            // {
            //     label: "Add New",
            //     path: settings.path + "/create"
            // },
        ]

    },
    indexButtons: (routeName, params, users) => {

        return [
            // {
            //     label: "Add New",
            //     path: settings.path + '/create',
            //     caps: settings.createCaps
            // }
        ]

    },
    indexTabCounts: (routeName, params, dontation) => {

        return settings.endpoint + "/getCounts";

    },
    indexFetch: PaymentApi.get,
    indexFetchParams: (routeName, params, users) => {

        const filters: any = { where: { status: "paid" }, include: ['order', 'owner', 'host'], order: ['created.date DESC'], limit: 10, skip: 0 };

        if (params && params.status) filters.where.status = { inq: [params.status] };

        return filters;

    },
    indexQuickSearch: (routeName, params, users) => {

        const fields = ['id', 'orderId'];

        return fields;

    },
    indexSearchFields: (routeName, params, users) => {

        const fields = [
            {
                label: "Payment #",
                key: "id",
                type: "text",
            },
            {
                label: "Customer",
                key: "ownerId",
                type: "relationship",
                model: "Users",
            },
            {
                label: "Order",
                key: "orderId",
                type: "relationship",
                model: "Order",
            },
        ];

        return fields;

    },

    indexColumns: (routeName, params, users) => {

        const columns = [
            {
                label: "Transaction #",
                key: "this",
                format: "ModelLink",
                sort: "id",
            },
            {
                label: "Status",
                key: "status",
                format: "titleCase",
            },
            {
                label: "Order #",
                key: "order",
                format: "ModelLink",
            },
            {
                label: "Customer",
                key: "owner",
                format: "ModelLink",
            },
            {
                label: "Host",
                key: "host",
                format: "ModelLink",
            },
            {
                label: "Amount",
                key: "amount",
                format: "number"
            },
            {
                label: "Amount Paid",
                key: "amountPaid",
                format: "number"
            },
            {
                label: "Created Date",
                key: "created",
                format: "OnAndBy",
                sort: "created.date",
                alignEnd: true
            },
            {
                label: "Date Paid",
                key: "datePaid",
                format: "dateTime",
                sort: "datePaid",
                alignEnd: true
            },
            {
                label: "Actions",
                key: "actions",
                alignEnd: true,
                render: (value, data) => {

                    return <PaymentActions data={data} />;

                }
            }
        ];

        return columns;

    },
    singleFetch: PaymentApi.getOne,
    singleFetchParams: (routeName, params, users, fetch) => {

        const filters = { include: ['order', 'host', 'owner'] };

        return filters;

    },
    singleTitle: (routeName, params, users, fetch) => {

        let title: string = "Loading...";

        const complete = get(fetch, 'complete');
        const error = get(fetch, 'error');
        const data = get(fetch, 'data');

        if (error) title = "Error";
        else if (data) title = data[settings.primaryKey];
        else if (complete && !data) title = "Not Found";

        return title;

    },
    singleTabs: (routeName, params, users, fetch) => {

        const path = settings.path + "/" + params.id;

        return [
            {
                label: "View",
                path: path + "/view"
            },
            // {
            //     label: "Edit",
            //     path: path + "/edit"
            // },
        ]

    },
};